/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc 利用規約パネル
 *
 * @author genka
 * @copyright Copyright 2021 TechMatrix Corporation, Inc. All rights reserved.
 */
<template>
<el-container class="fc-user-policy-pane">

  <el-main class="main-area">
    <div class="user-policy-text" v-html="userPolicyText">
    </div>
  </el-main>

  <el-footer class="footer-area" height="auto">
    <el-button type="primary" class="user-policy-agree-button" @click="doAgree">{{agreeButtonLabel}}</el-button>
  </el-footer>

</el-container>
</template>

<script>
import {
  Container,
  Main,
  Footer,
  Button
} from 'element-ui'

export default {
  name: 'FcUserPolicyPane',
  components: {
    'el-container': Container,
    'el-main': Main,
    'el-footer': Footer,
    'el-button': Button
  },
  data() {
    return {}
  },
  computed: {
    /**
     * 利用規約内容
     * @return {string}
     */
    userPolicyText() {
      return this.$config.userPolicyDisplayConfig.userPolicyText
    },
    /**
     * 利用規約の同意ボタンラベル
     * @return {string}
     */
    agreeButtonLabel() {
      return this.$config.userPolicyDisplayConfig.agreeButtonLabel
    }
  },
  methods: {
    /**
     * 同意ボタン処理
     */
    doAgree() {
      this.$emit('userPolicyAgree')
    }
  }
}
</script>

<style scoped>
.fc-user-policy-pane {
  height: auto;
}

.main-area {
  background-color: rgb(142, 211, 251);
  flex: 2;
}

.footer-area {
  padding: 10px;
  background: #99a9bf;
}

.user-policy-agree-button {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/chatWindow/userPolicy/FcUserPolicyPane.vue